<script setup lang="ts">
import { computed, ref } from 'vue';
import i18n from '@/i18n';
import { every, isEmpty } from 'lodash';
import { LANG_ENGLISH } from '@/constants';
import { useComponentComposable } from '@/components/useComponentComposable';
import Carousel from 'primevue/carousel';
import PromoBoxesCard from './PromoBoxesCard.vue';

interface Props {
  value: any[];
  horizon?: boolean;
  isAdminPage?: boolean;
  section: any;
}
const props = defineProps<Props>();

const { renderHTMLContent } = useComponentComposable();
const currentLanguage = i18n.global.locale.value;

const promos = computed(() => {
  const payload = [...props.value];

  return payload.filter((p) => {
    return props.isAdminPage ? !every(p, isEmpty) : p.isShow && !every(p, isEmpty);
  });
});

const sectionTitle = computed(() => {
  return (currentLanguage === LANG_ENGLISH ? props.section.promoBoxTitleEn : props.section.promoBoxTitleFr) || '';
});

const screenWidth = {
  desktop: '1199px',
  tablet: '991px',
  mobile: '516px'
};

const responsiveOptions = ref([
  {
    breakpoint: screenWidth.desktop,
    numVisible: 3,
    numScroll: 1
  },
  {
    breakpoint: screenWidth.tablet,
    numVisible: 2,
    numScroll: 1
  },
  {
    breakpoint: screenWidth.mobile,
    numVisible: 1,
    numScroll: 1
  }
]);
</script>
<template>
  <Carousel
    v-if="promos.length"
    :value="promos"
    :orientation="horizon ? 'horizontal' : 'vertical'"
    verticalViewPortHeight="680px"
    class="custom-carousel promo-box"
    :numVisible="isAdminPage ? 1 : 3"
    :numScroll="isAdminPage ? 0 : 1"
    :responsiveOptions="responsiveOptions"
  >
    <template #header>
      <renderHTMLContent :data="sectionTitle" htmlElement="h2"></renderHTMLContent>
    </template>
    <template #item="slotProps">
      <PromoBoxesCard :products="slotProps.data" />
    </template>
  </Carousel>
</template>
